<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal">
        <header class="modal-header">
          <h2><slot name="header"></slot></h2>
            <button
              type="button"
              class="btn-close"
              @click="close"
            >
              x
            </button>
        </header>
        <section class="modal-body">
          <p>
            <slot name="body"></slot>
          </p>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TextModal',
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 4;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 32px);
    width: calc(100vw - 32px);
    margin: 16px;
  }

  .modal-header {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;

    & h2::first-letter {
      text-transform: capitalize;
    }
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
    flex: 1;

    & p::first-letter {
      text-transform: capitalize;
    }
  }

  .btn-close {
    border: none;
    font-size: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }

 .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }
</style>



// WEBPACK FOOTER //
// src/components/TextModal.vue